import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { CheckCircle2 } from 'lucide-react';
export function AboutPage() {
  return <div className="flex flex-col min-h-screen pt-24 pb-20" data-id="element-161">
      {/* Hero */}
      <section className="relative bg-gray-50 py-16 md:py-24 overflow-hidden" data-id="element-162">
        <div className="absolute inset-0 z-0" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/wnobZn5RhLEJjxEVY4Ttz2/About_Us-hero.jpg" alt="Craftsman at work" className="w-full h-full object-cover object-center" data-id="element-164" />
          <div className="absolute inset-0 bg-white/85" data-id="element-165"></div>
        </div>

        <div className="container relative z-10 mx-auto px-4 md:px-6" data-id="element-166">
          <div className="max-w-3xl mx-auto text-center" data-id="element-167">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-168">
              Your Trusted Partner for Bathroom Remodeling in Northern Indiana
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-169">
              A family-owned business committed to quality craftsmanship, honest
              service, and transforming bathrooms throughout Northern Indiana
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16" data-id="element-170">
        <div className="container mx-auto px-4 md:px-6" data-id="element-171">
          <div className="grid md:grid-cols-2 gap-12 items-start mb-16" data-id="element-172">
            <div className="relative" data-id="element-173">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-xl" data-id="element-174">
                <img src="https://cdn.magicpatterns.com/uploads/hEEE7RUiP6EFKkLUTz7XyQ/ABout_Us2.jpg" alt="Lucky Duck Bathroom Company team at work" className="w-full h-full object-cover" data-id="element-175" />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-lg max-w-xs hidden md:block" data-id="element-176">
                <p className="text-[#8BA888] font-bold text-lg mb-1" data-id="element-177">
                  "Quality craftsmanship, every time."
                </p>
                <p className="text-sm text-gray-500" data-id="element-178">- Our Promise to You</p>
              </div>
            </div>

            <div className="space-y-8" data-id="element-179">
              <div data-id="element-180">
                <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-181">
                  Our Story
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-182">
                  At Lucky Duck Bathroom Company, our story is built on a simple
                  but powerful principle: quality always comes before speed.
                  While many bathroom remodeling companies in Northern Indiana
                  rush through installations to maximize volume, we take a
                  different approach. We believe that your bathroom renovation
                  deserves the time, attention, and craftsmanship necessary to
                  create results that truly last.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-183">
                  As a family-owned and operated business, we're deeply rooted
                  in the Northern Indiana community we serve. Our reputation
                  isn't built on flashy marketing or high-pressure sales
                  tactics—it's earned through honest work, quality materials,
                  and the satisfaction of homeowners who trust us with their
                  most important investment: their home.
                </p>
              </div>

              <div data-id="element-184">
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-185">
                  Our Philosophy
                </h3>
                <p className="text-gray-600 leading-relaxed mb-4" data-id="element-186">
                  We're not just another one-day bath company promising quick
                  fixes. Lucky Duck Bathroom Company is a team of dedicated
                  professionals who believe in personal, client-focused service
                  that puts your needs first. We understand that a bathroom
                  remodel represents a significant investment in your home and
                  your family's comfort, which is why our goal is to make the
                  entire process as stress-free and transparent as possible.
                </p>
                <p className="text-gray-600 leading-relaxed" data-id="element-187">
                  From your very first consultation through the final
                  installation and walkthrough, we focus on two things above all
                  else: exceptional craftsmanship and clear, honest
                  communication. We take the time to listen to your vision,
                  understand your specific needs, and explain every step of the
                  process. You'll never be left wondering what's happening with
                  your project or when we'll be back to complete the next phase.
                </p>
              </div>
            </div>
          </div>

          {/* What Makes Us Different Section */}
          <div className="max-w-4xl mx-auto" data-id="element-188">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-189">
              What Makes Us Different
            </h3>
            <ul className="space-y-6 mb-12" data-id="element-190">
              <li className="flex items-start gap-4" data-id="element-191">
                <CheckCircle2 className="h-6 w-6 text-[#8BA888] shrink-0 mt-1" data-id="element-192" />
                <div data-id="element-193">
                  <span className="font-bold text-gray-900 text-lg" data-id="element-194">
                    Quality First, Always:
                  </span>
                  <p className="text-gray-700 mt-1" data-id="element-195">
                    {' '}
                    We never cut corners or compromise on materials. Every
                    bathroom remodeling project we complete uses high-quality
                    products and proven installation techniques to ensure your
                    new shower, vanity, or complete bathroom renovation is not
                    only beautiful but built to withstand years of daily use.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-196">
                <CheckCircle2 className="h-6 w-6 text-[#8BA888] shrink-0 mt-1" data-id="element-197" />
                <div data-id="element-198">
                  <span className="font-bold text-gray-900 text-lg" data-id="element-199">
                    Personalized Service:
                  </span>
                  <p className="text-gray-700 mt-1" data-id="element-200">
                    {' '}
                    Your home is unique, and so are your needs. We take the time
                    to truly listen to your vision, preferences, and concerns,
                    crafting customized bathroom solutions that are perfectly
                    suited to your space, style, and budget. You're not just
                    another job number—you're a valued member of our community.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-201">
                <CheckCircle2 className="h-6 w-6 text-[#8BA888] shrink-0 mt-1" data-id="element-202" />
                <div data-id="element-203">
                  <span className="font-bold text-gray-900 text-lg" data-id="element-204">
                    No Pressure, Just Honest Advice:
                  </span>
                  <p className="text-gray-700 mt-1" data-id="element-205">
                    {' '}
                    We believe in straightforward, transparent communication
                    without pushy sales tactics. Our goal is to empower you with
                    the information and guidance you need to make the best
                    decision for your family and your home. There's never any
                    pressure or obligation—just honest, professional advice you
                    can trust.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-206">
                <CheckCircle2 className="h-6 w-6 text-[#8BA888] shrink-0 mt-1" data-id="element-207" />
                <div data-id="element-208">
                  <span className="font-bold text-gray-900 text-lg" data-id="element-209">
                    The Right Way, Not the Rushed Way:
                  </span>
                  <p className="text-gray-700 mt-1" data-id="element-210">
                    {' '}
                    A quality remodel requires proper demo, careful prep,
                    waterproofing, and precise installation — plus permits and
                    inspections when required. We build timelines around
                    craftsmanship and long-term durability, so your finished
                    bathroom looks great and performs well for years to come.
                  </p>
                </div>
              </li>
            </ul>

            {/* Ask Your Remodeler Callout */}
            <div className="bg-[#8BA888]/8 border border-[#8BA888]/20 rounded-xl p-6 mb-10" data-id="element-211">
              <p className="text-sm font-semibold text-[#8BA888] uppercase tracking-wide mb-4" data-id="element-212">
                When comparing remodelers, always ask:
              </p>
              <ul className="space-y-3" data-id="element-213">
                {['Will permits be obtained if required by your local area?', 'What waterproofing and prep steps are included in the scope?', 'Who is doing the work — an accountable crew with one clear point of contact?'].map((q, i) => <li key={i} className="flex items-start gap-3" data-id="element-214">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#8BA888]/15 text-[#8BA888] font-bold text-sm mt-0.5" data-id="element-215">
                      {i + 1}
                    </span>
                    <span className="text-gray-700" data-id="element-216">{q}</span>
                  </li>)}
              </ul>
              <p className="mt-5 text-gray-700 font-medium" data-id="element-217">
                Our answer to all three:{' '}
                <span className="text-[#1E3A5F] font-bold" data-id="element-218">
                  quality first, clear communication, and a remodel you can
                  trust.
                </span>
              </p>
            </div>

            <div className="text-center pt-6 border-t border-gray-200" data-id="element-219">
              <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-220">
                Whether you're looking for a complete bathroom remodel, a
                tub-to-shower conversion, custom tile work, or accessibility
                upgrades, Lucky Duck Bathroom Company brings the same commitment
                to quality and customer satisfaction to every project. We can't
                wait to help you transform your bathroom into the beautiful,
                functional space you deserve.
              </p>
              <Link to="/contact" data-id="element-221">
                <Button size="lg" data-id="element-222">Schedule Your Free Consultation</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}